import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import base64url from "base64url";
import qs from 'qs';
import { Auth } from '@janiscommerce/sdk'

import { accessTokenCookieName, idTokenCookieName, oauthClientId, oauthRedirectPath, pkceVerifierCookieName, tokenEndpoint } from '../constants';

const options = {
	client_id: oauthClientId,
	scope: 'openid profile',
	redirect_uri: `${window.location.origin}${oauthRedirectPath}`
};

const authClient = new Auth(options);

const useOAuthTokens = (shouldGenerate = true) => {

	const [error, setError] = useState(null);
	const [fetching, setFetching] = useState(false);
	const [redirectUrl, setRedirectUrl] = useState(null);
	const [tokens, setTokens] = useState(null);

	const [cookies, setCookie] = useCookies([accessTokenCookieName, idTokenCookieName, pkceVerifierCookieName]);

	useEffect(() => {

		const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });

		if(query.error) {
			setError(new Error(`${query.error}: ${query.error_description}`));
			return;
		}

		if(!query.code) {
			setError(new Error('Missing authorization code'));
			return;
		}

		const getTokens = async () => {

			try {
				const tokensData = await authClient.getTokens({
					code: query.code,
					codeVerifier: cookies[pkceVerifierCookieName]
				}, tokenEndpoint);

				const cookiesParams = {
					path: '/',
					maxAge: tokensData.expiresIn
				};

				setCookie(accessTokenCookieName, tokensData.accessToken, cookiesParams);
				setCookie(idTokenCookieName, tokensData.idToken, cookiesParams);
				setTokens(tokensData);

				if(query.state) {
					try {
						const state = JSON.parse(base64url.decode(query.state));
						if(state && state.location) {
							setRedirectUrl(state.location);
						}
					} catch(e) {
					}
				}
			} catch(e) {
				setError(e);
			}
		}

		if(fetching) {
			return;
		}

		setFetching(true);

		getTokens();
	}, [cookies, fetching, setCookie, tokens]);

	return {
		error,
		redirectUrl,
		tokens
	};
};

export default useOAuthTokens;
